/* eslint-disable @typescript-eslint/no-explicit-any */
// config/org.config.ts
import {services as bometServices} from './icrms/services';


export const bometConfig = {
  name: 'BometPay - Customer Portal',
  themeMode: 'light', // default: "light" | can toggle dynamically
  theme: {
    light: {
      primary: '#006300',
      secondary: 'rgba(44, 149, 191, 1)',
      accent: 'rgba(191, 44, 71, 1)',
      background: '#ffffff',
      foreground: '#171717',
      'surface-header': '#FFFCEE',
    },
    dark: {
      primary: '#006300',
      secondary: 'rgba(44, 149, 191, 1)',
      accent: 'rgba(191, 44, 71, 1)',
      background: '#0a0a0a',
      foreground: '#ededed',
      'surface-header': '#FFFCEE',
    },
  },
  logo: '/bomet/logo.svg',
  favicon: '/bomet/favicon-64.png',
  faviconSvg: '/bomet/favicon.svg',
  favicon64: '/bomet/favicon-64.png',
  favicon128: '/bomet/favicon-128.png',

  auth: {
    signin: {
      heroImage: '/images/b_auth.png',
    },
  },

  heroSection: {
    title: (
      <>
        <span className="text-white md:text-black font-bold">BometPay </span>
        <span className="text-white md:text-black">
          – fast & <br /> secure
        </span>{' '}
        <span className="text-white md:text-black">county payments</span>
      </>
    ),
    description: (
      <span className="text-white md:text-black">
        Experience hassle-free payments for county <br /> services with just a
        few clicks.
      </span>
    ),
    image: '/bomet/images/herosection.svg',
  },

  servicesSection: {
    title: (
      <>
        <strong>Bomet County</strong> Government Services
      </>
    ),
    description: (
      <>
        The Bomet County Portal enables you to access and make payments for a
        wide range of services from the County Government of Bomet. Please
        select a service below to proceed.
      </>
    ),
    services: bometServices, // 👈 loaded from config/bomet/services.ts
  },
  contact: {
    hq: {
      coords: [-0.7867813544885653, 35.33626199348885], // Example: Bomet town coords
      label: 'Bomet County Headquarters – Bomet Town',
    },
    details: [
      {
        id: 'postal',
        label: 'Postal Address',
        value: (
          <>
            19-20400,
            <br />
            Bomet
          </>
        ),
      },
      {
        id: 'email',
        label: 'Email',
        value: <>info@bomet.go.ke</>,
      },
      {
        id: 'tel',
        label: 'Telephone',
        value: <>0202084068 / 69 / 70</>,
      },
      {
        id: 'ambulance',
        label: 'Ambulance Service',
        value: <>0707 584 327</>,
      },
      {
        id: 'fire',
        label: 'Fire or Any Other Disaster',
        value: <>0775 281 877</>,
      },
      {
        id: 'security',
        label: 'Security Matters',
        value: <>0722 036 036</>,
      },
    ],
  },
  footer: {
    description:
      'The Bomet County Service Portal provides easy access to a wide range of services, from business licenses to essential services. Pay securely and manage all your county-related tasks from one platform.',
    copyright: '© 2025 County Government of Bomet. All rights reserved.',
    links: [
      { title: 'Home', url: '/' },
      { title: 'Services', url: '#services' },
      { title: 'Contact Us', url: '/contact/' },
    ],
  },
  getApiBaseUrl: () => {
    if (typeof window !== 'undefined') {
      return (window as any).__RUNTIME_CONFIG__?.NEXT_PUBLIC_BASE_API;
    }
    return process.env.NEXT_PUBLIC_BASE_API;
  },
};
